import React from 'react';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeFourTitle = props => {
	return (
		<div
			className="themes-theme-four-title new-container"
			style={{
				color:
					props.home.operator &&
					props.home.operator.color_codes &&
					props.home.operator.color_codes.primary_text_color &&
					props.home.operator.color_codes.primary_text_color,
			}}
		>
			{props.home.operator && props.home.operator.operator_name === 'santajuana' || props.home.operator && props.home.operator.operator_name === 'losnavegadores' ? (
				<span className="bold-text">{props.title}</span>
			) : (
				<div class="mt-5">
					<img src={getIcons('titleLeftIcon')} alt="" className="title-icon" />
					<span className="bold-text px-1">{props.title}</span>
					<img src={getIcons('titleRightIcon')} alt="" className="title-icon" />
				</div>
			)}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
	};
}

export default connect(mapStateToProps, {})(ThemeFourTitle);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourTitle.js